import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import scroll from 'scroll';
import '../../styles/accordion.scss';

/* For the scroll to panel to work, a wrapper parent with position: relative is needed.
   The accordion uses the closest relative parent as a reference for where to
   scroll to from the top.
*/
const propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.bool])),
  springConfig: PropTypes.object,
  initialIndex: PropTypes.number,
  onChange: PropTypes.func,
};

const defaultProps = {
  className: '',
  children: null,
  springConfig: { stiffness: 250, damping: 30 },
  initialIndex: null,
  onChange: () => {},
};

class Accordion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: props.initialIndex,
      isOpen: _.isNumber(props.initialIndex),
      focusTo: 0,
      init: _.isNumber(props.initialIndex),
    };
  }

  getTitleElement(panel) {
    return _.find(panel.element.childNodes, (node) => {
      if (node.className.indexOf('bar') > -1) {
        return node;
      }
      return null;
    });
  }

  // Update panel open status
  updatePanels(panels) {
    return React.Children.map(
      panels,
      (panel, index) =>
        panel &&
        React.cloneElement(panel, {
          isOpen: index === this.state.index ? this.state.isOpen : false,
          clickHandler: this.togglePanel,
          springConfig: this.props.springConfig,
          onMeasure: this.scrollTo,
          index,
          last: index === panels.length - 1,
          ref: index === this.props.initialIndex ? 'initialPanel' : `${panel.key}Panel`,
        }),
    );
  }

  togglePanel = (event, panel) => {
    event.preventDefault();
    // State of new panel
    const index = _.get(panel, 'props.index');
    const isOpen = !_.get(panel, 'props.isOpen');

    // State of previous panel
    this.setState({
      previousIndex: this.state.index,
      previousIsOpen: this.state.isOpen,
      previousPanel: this.state.panel,
    });

    const latestState = { index, isOpen, panel, init: false };
    this.setState(latestState);
    this.props.onChange(latestState);
  };

  scrollTo = (rectangle, panel) => {
    if (this.state.init) {
      this.setState({
        previousIndex: this.state.index,
        previousIsOpen: this.state.isOpen,
        previousPanel: panel,
        panel,
      });
      return;
    }

    const differentPanel = this.state.previousPanel !== this.state.panel;
    const previousOpen = this.state.previousIsOpen;
    const currentOpen = this.state.isOpen;
    const previousPanelIndex = this.state.previousIndex;
    const currentPanelIndex = _.get(this.state.panel, 'props.index');

    // Case where an existing panel is open and a different panel is then opened
    if (previousOpen && currentOpen) {
      // Scroll to the newly opened panel and not the closed panel
      if (differentPanel && panel === this.state.panel) {
        /* Scroll to location changes depending if the new panel is above or
         below the previously opened panel */
        if (currentPanelIndex > previousPanelIndex) {
          const previousPanel = this.state.previousPanel || this.refs.initialPanel;
          const previousPanelHeight = _.get(previousPanel, 'element.clientHeight', 0);
          const prevPanelTitle = this.getTitleElement(previousPanel);

          // Account for height of previous panel's title
          const adjustedPrevPanelHeight = previousPanelHeight - prevPanelTitle.offsetHeight;
          scroll.top(document.body, panel.element.offsetTop - adjustedPrevPanelHeight);
        } else {
          scroll.top(document.body, panel.element.offsetTop);
        }
      }
    } else {
      scroll.top(document.body, panel.element.offsetTop);
    }
  };

  render() {
    const updatedPanels = this.updatePanels(this.props.children);

    return <div className={cx('accordion', this.props.className)}>{updatedPanels}</div>;
  }
}

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
export default Accordion;
